import { GET, POST } from '@/shared/api/requests';
import {
  AnalyticsData,
  Client,
  DashboardData,
  Project,
  ProjectMapData,
  UserClientProjectsData,
} from '@/types/base';

// Dashboard API
export const getDashboard = async (clientName: string): Promise<DashboardData> => {
  return (await GET(`/base/dashboard/${clientName}/`)).data;
};

/** Deactivate the current user's membership on a project (leave project). */
export const deactivateOwnProjectMembership = async (
  projectId: number,
): Promise<{ id: number; is_active: boolean }> => {
  const response = await POST(`/rbac/projects/${projectId}/memberships/self/deactivate/`, {});
  return response.data as { id: number; is_active: boolean };
};

// Clients API
export const getClientsByRegion = async (region: 'Denver' | 'Austin' = 'Denver'): Promise<{ clients: Client[] }> => {
  const response = await GET(`/base/clients/?region=${region}`);
  // With pagination disabled, the API returns an array directly
  // Wrap it in an object for consistency with the expected format
  return { clients: response.data };
};

// Projects API
export const getAllProjects = async (params?: { 
  search?: string; 
  status?: 'active' | 'completed' 
}): Promise<Project[]> => {
  const queryParams = new URLSearchParams();
  if (params?.search) queryParams.append('search', params.search);
  if (params?.status) queryParams.append('status', params.status);
  
  const url = `/base/projects/${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  const response = await GET(url);
  
  // With pagination disabled on the backend, this should return an array directly
  return response.data;
};

export const getUserClientProjects = async (): Promise<UserClientProjectsData> => {
  return (await GET('/base/user/client-projects/')).data;
};

export const getProjectMap = async (): Promise<ProjectMapData> => {
  return (await GET('/base/projects/map/')).data;
};

export const getProjectClients = async (projectId: number): Promise<{ clients: Client[] }> => {
  return (await GET(`/base/projects/${projectId}/clients/`)).data;
};

// Analytics API
export const getStaffAnalytics = async (): Promise<AnalyticsData> => {
  return (await GET('/base/analytics/staff/')).data;
};

